/**
 * Site-wide constants. Values that vary per deployment come from Vite env
 * vars (see .env files / vite.config.ts); everything here has a safe default
 * so a bare `npm run dev` works with no configuration.
 */
export const SITE_NAME = 'Peacock Omlettes';
export const SITE_URL = (import.meta.env.VITE_SITE_URL ?? 'https://peacockomlettes.com').replace(
  /\/+$/,
  '',
);

/**
 * AdSense publisher ID (ca-pub-XXXXXXXXXXXXXXXX). Empty until the AdSense
 * account is approved; while empty, AdSlot renders a labeled placeholder and
 * index.html ships no Google code (stripped at build time).
 */
export const ADSENSE_CLIENT = (import.meta.env.VITE_ADSENSE_CLIENT ?? '').trim();

/** Numeric data-ad-slot IDs from AdSense > Ads > By ad unit. Optional. */
export const ADSENSE_SLOTS = {
  display: (import.meta.env.VITE_ADSENSE_SLOT_DISPLAY ?? '').trim(),
  inArticle: (import.meta.env.VITE_ADSENSE_SLOT_INARTICLE ?? '').trim(),
};

/**
 * Contact address published on the legal pages. TODO: point a real inbox at
 * this (e.g. an SES-forwarded alias) before launch.
 */
export const CONTACT_EMAIL = 'contact@peacockomlettes.com';
